import User from "./modules/user";

const routerPc = [
  {
    path: "/", // 首页
    name: "Index",
    meta: {
      keepAlive: true,
      title: "首页"
    },
    component: () => import("@/views/pc/Index")
  },
  {
    path: "/Login", // 登录
    name: "Login",
    meta: {
      keepAlive: false,
      title: "登录"
    },
    component: () => import("@/views/pc/Login")
  },
  {
    path: "/process", // 登录
    name: "Process",
    meta: {
      keepAlive: false,
      title: "乐托品流程"
    },
    component: () => import("@/views/pc/Process")
  },
  {
    path: "/SignUp", // 注册
    component: () => import("@/views/pc/SignUp"),
    children: [
      {
        path: "/",
        name: "index",
        meta: {
          keepAlive: false,
          title: "注册"
        },
        component: () => import("@components/pc/signUp/CheckPhone")
      },
      {
        path: "checkPhone",
        name: "CheckPhone",
        meta: {
          keepAlive: false,
          title: "验证号码"
        },
        component: () => import("@components/pc/signUp/CheckPhone")
      },
      {
        path: "inputInfo",
        name: "InputInfo",
        meta: {
          keepAlive: false,
          title: "信息输入"
        },
        component: () => import("@components/pc/signUp/InputInfo")
      },
      {
        path: "signUpDone",
        name: "SignUpDone",
        meta: {
          keepAlive: false,
          title: "注册完成"
        },
        component: () => import("@components/pc/signUp/SignUpDone")
      }
    ]
  },
  {
    path: "/retrievePassword", // 找回密码
    name: "RetrievePassword",
    meta: {
      keepAlive: true,
      title: "找回密码"
    },
    component: () => import("@/views/pc/RetrievePassword")
  },
  {
    path: "/goodsList", // 商品搜索列表
    name: "GoodsList",
    meta: {
      keepAlive: true,
      title: "商品列表"
    },
    component: () => import("@/views/pc/GoodsList")
  },
  {
    path: "/goodsCategory", // 商品分类列表
    name: "GoodsCategory",
    meta: {
      keepAlive: true,
      title: "商品列表"
    },
    component: () => import("@/views/pc/GoodsCategory")
  },
  {
    path: "/goodsDetail/:id", // 商品详情
    name: "GoodsDetail",
    meta: {
      keepAlive: false,
      title: "商品详情"
    },
    component: () => import("@/views/pc/GoodsDetail")
  },
  {
    path: "/groupDetail/:id", // 商品详情
    name: "GroupDetail",
    meta: {
      keepAlive: false,
      title: "商品详情"
    },
    component: () => import("@/views/pc/GroupDetail")
  },
  {
    path: "/order/:cardId", // 订单页面
    name: "Order",
    meta: {
      keepAlive: false,
      title: "订单页面"
    },
    component: () => import("@/views/pc/Order")
  },
  {
    path: "/news", // 资讯列表
    name: "News",
    meta: {
      keepAlive: true,
      title: "资讯列表"
    },
    component: () => import("@/views/pc/News")
  },
  {
    path: "/newsDetail/:id", // 资讯详情页
    name: "NewsDetail",
    meta: {
      keepAlive: false,
      title: "资讯详情页"
    },
    component: () => import("@/views/pc/NewsDetail")
  },
  {
    path: "/pay", // 支付页面
    name: "Pay",
    meta: {
      keepAlive: false,
      title: "支付页面"
    },
    component: () => import("@/views/pc/Pay")
  },
  {
    path: "/freeback", // 反馈页面
    name: "Freeback",
    meta: {
      keepAlive: false,
      title: "反馈页面"
    },
    component: () => import("@/views/pc/Freeback")
  },
  ...User,
  {
    path: "/shoppingCart",
    name: "ShoppingCart",
    meta: {
      keepAlive: false,
      auth: true,
      title: "购物车列表"
    },
    component: () => import("@/views/pc/ShoppingCart")
  },
  {
    path: "/merchant",
    name: "Merchant",
    meta: {
      keepAlive: false
    },
    component: () => import("@/views/pc/Merchant")
  },
  {
    path: "/buyDrug",
    name: "BuyDrug",
    meta: {
      keepAlive: false
    },
    component: () => import("@/views/pc/BuyDrug")
  },
  {
    path: "/patient",
    name: "Patient",
    meta: {
      keepAlive: false,
      auth: true,
      title: "患者认证"
    },
    component: () => import("@/views/pc/Patient")
  },
  {
    path: "/company",
    name: "Company",
    meta: {
      keepAlive: false,
      title: "企业认证"
    },
    component: () => import("@/views/pc/Company")
  },
  {
    path: "/helpCenter",
    name: "HelpCenter",
    meta: {
      keepAlive: false
    },
    component: () => import("@/views/pc/HelpCenter")
  },
  {
    path: "*",
    name: "NotFind",
    meta: {
      keepAlive: true
    },
    component: () => import("@/views/pc/NotFind")
  }
];

export default routerPc;
